// extracted by mini-css-extract-plugin
export default {"container":"v7Vv1d","navigation":"dp0LUy","large":"i05953","small":"OFbRa6"};